@if (visible) {
  <div class="spinner-border text-primary text-center small" role="status"></div>
}